import template from './SPopupDialog.html';

export default {
	template,
	props: ['data'],
	data() {
		return {
			dialogShown: false
		};
	},
	methods: {
		resolveDialog(val) {
			if (val === undefined) {
				val = this.data.cancelVal;
			}
			this.data.resolve(val);
			this.dialogShown = false;
		},
	},
	watch: {
		data() {
			this.dialogShown = !!this.data;
		}
	}
};